import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import SummaryApi from '../common'; 

const UserVerifyEmail = () => {
    const [otp, setOtp] = useState(['', '', '', '']);
    const [email, setEmail] = useState('');
    const [resending, setResending] = useState(false);
    const [resendCooldown, setResendCooldown] = useState(false); // State to handle resend cooldown
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state?.email) {
            setEmail(location.state.email);
        } else {
            toast.error('دخول غير مسموح');
            navigate('/sign-up');
        }
    }, [location.state, navigate]);

    useEffect(() => {
        // If resendCooldown is true, start a 10-second timer to reset it
        if (resendCooldown) {
            const timer = setTimeout(() => {
                setResendCooldown(false);
            }, 10000); // 10 seconds
            return () => clearTimeout(timer); // Clear timer on component unmount
        }
    }, [resendCooldown]);

    const handleChange = (e, index) => {
        const { value } = e.target;
        if (/^[0-9]?$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            if (value && index < otp.length - 1) {
                document.getElementById(`otp-input-${index + 1}`).focus();
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const otpString = otp.join('');

        try {
            const response = await fetch(SummaryApi.userMailOTPVerify.url, {
                method: SummaryApi.userMailOTPVerify.method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, otp: otpString }),
            });

            const data = await response.json();
            if (data.success) {
                toast.success('تم التحقق من الرمز بنجاح');
                navigate('/login');
            } else {
                toast.error(data.message);
                toast.error(' غير صحيح، يرجى المحاولة مرة أخرى OTP');
            }
        } catch (error) {
            toast.error('حدث خطأ. يرجى المحاولة مرة أخرى');
        }
    };

    const handleResendOtp = async () => {
        if (resendCooldown) return; // Prevent resending if within cooldown period

        setResending(true);
        try {
            const response = await fetch(SummaryApi.userMailSendVerification.url, {
                method: SummaryApi.userMailSendVerification.method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();
            if (data.success) {
                toast.success('تم إرسال رمز التحقق بنجاح');
                setResendCooldown(true); // Start cooldown period
            } else {
                toast.error(data.message);
                toast.error('لقد تخطيت الوقت المسموح به للتوثيق وتم الغاء الحساب من فضلك اعد انشاء حساب من جديد');
            }
        } catch (error) {
            toast.error('حدث خطأ. يرجى المحاولة مرة أخرى');
        } finally {
            setResending(false); // Re-enable button after the request
        }
    };

    return (
        <section id='otp-page'>
            <div className='mx-auto container p-4'>
                <div className='bg-white p-5 w-full max-w-sm mx-auto'>
                    <form className='pt-6 flex flex-col gap-2' onSubmit={handleSubmit}>
                        <div className='flex justify-between'>
                            {otp.map((digit, index) => (
                                <input
                                    key={index}
                                    id={`otp-input-${index}`}
                                    type='text'
                                    maxLength='1'
                                    value={digit}
                                    onChange={(e) => handleChange(e, index)}
                                    className='w-12 h-12 text-center text-xl border border-gray-300 rounded'
                                />
                            ))}
                        </div>
                        <div className='flex justify-center'>
                            <button
                                type='submit'
                                className='flex items-center justify-center bg-blue-900 text-white px-4 py-2 text-sm rounded-full shadow-md hover:bg-blue-800 transition-colors duration-300 w-[120px] text-center'
                            >
                                 OTP تاكيد 
                            </button>
                        </div>
                        <div className='flex justify-center mt-4'>
                            <button
                                type='button'
                                onClick={handleResendOtp}
                                disabled={resending || resendCooldown} // Disable button during resend and cooldown
                                className='text-red-600 underline'
                            >
                                {resending ? 'إرسال الرمز...' : resendCooldown ? ' اعادة عملية الارسال خلال 10 ثوان ستكون متاحة' : 'لم يصل الرمز ؟ اعادة العملية من جديد'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default UserVerifyEmail;
